import { render, staticRenderFns } from "./CustomerListCreate.vue?vue&type=template&id=36a1e598&"
import script from "./CustomerListCreate.vue?vue&type=script&lang=js&"
export * from "./CustomerListCreate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports